import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PersonalMonthlyNetLossThresholdDTO } from './personal-monthly-net-loss-threshold.model';

@Injectable({
  providedIn: 'root',
})
export class PersonalMonthlyNetLossThresholdService {
  constructor(private http: HttpClient) {}

  public update(playerId: number, dto: PersonalMonthlyNetLossThresholdDTO): Observable<void> {
    return this.http.put<void>(`/player-activity/api/players/${playerId}/monthly-net-loss-threshold`, dto);
  }

  public get(playerId: number): Observable<PersonalMonthlyNetLossThresholdDTO> {
    return this.http.get<PersonalMonthlyNetLossThresholdDTO>(
      `/player-activity/api/players/${playerId}/monthly-net-loss-threshold`
    );
  }
}
